import { portalAction, portalScreenContext } from '../../../../app/telemetry/portalTelemetry';
import { usePortalScreen } from '../../../../app/telemetry/usePortalTelemetry';
import { useMsal } from "@azure/msal-react";
import { Box, Grid, Typography } from "@mui/material";
import { useState, useEffect } from "react";
import { useFormContext } from "react-hook-form";
import { useGetWorkpostList } from "../../../../app/customHooks/useGetWorkpostList";
import { ApiRequestStatus } from "../../../../app/enums/apiRequestStatus";
import LoadingComponent from "../../../../app/layout/LoadingComponent";
import { IdTokenClaims } from "../../../../app/models/account/idTokenClaims";
import registrationFormModel from "../../../../app/models/pcsEnrolment/registrationFormModel";
import { WorkPostDto } from "../../../../app/models/workpost/workPostDto";
import { useAppSelector } from "../../../../app/store/configureStore";
import { MESSAGE_PROCESSING_DETAILS } from "../../../../app/utils/constant";
import { getLocalDateInString, pcsFilter, updateProfileWithRefLink } from "../../../../app/utils/util";
import { Link } from "react-router-dom";

export function WorkDetails() {
  const {
    workDetailsFormField: {
      StartDate,
      PostLevel,
      Country,
      NameOfClinicalSupervisor,
      NameOfEmployer,
      OtherNameOfEmployer,
      JobTitle
    }
  } = registrationFormModel;

  const methods = useFormContext();
  const { reset } = methods;

  const { instance } = useMsal();
  const userRoles = (instance.getActiveAccount()?.idTokenClaims as unknown as IdTokenClaims).extension_portalcrm_userType.split(',');

  const { countries, workPostLevels, hospitals } = useAppSelector(state => state.ReferenceData);
  const { workpostList, workpostListStatus } = useAppSelector(state => state.workpost);

  const [latestWorkpost, setLatestWorkpost] = useState<WorkPostDto>();

  useGetWorkpostList();

  useEffect(() => {
    if (workpostList && workpostList.length > 0) {
      setLatestWorkpost(workpostList?.slice().sort((a, b) => new Date(b.startDate).getTime() - new Date(a.startDate).getTime())[0]);
    }
  }, [workpostList]);

  useEffect(() => {
    reset({
      CurrentUserRoles: userRoles
    });
  }, []);

  usePortalScreen(portalScreenContext('WorkDetails'), undefined, !((workpostListStatus === ApiRequestStatus.Pending)));

  if (workpostListStatus === ApiRequestStatus.Pending) {
    return <LoadingComponent message={MESSAGE_PROCESSING_DETAILS} />
  }

  return <Box sx={{
    width: '96%', backgroundColor: '#e7e7e7', padding: '25px', marginTop: '10px'
  }}>
    <Grid container rowSpacing={4}>

      <Grid size={{ xs: 12 }}>
        <Typography variant='h5' sx={{ fontWeight: '550' }}>Current employment details</Typography>
      </Grid>

      <Grid size={{ xs: 12 }}>
        <Typography variant='subtitle2'>
          To Update work details please go to <Link target={'_blank'} rel="noreferrer" style={{ textDecoration: 'none' }}
            to={updateProfileWithRefLink()} onClick={portalAction(portalScreenContext('WorkDetails'), 'WorkDetails.navigate', () => { })}>my profile</Link> on the portal
        </Typography>
      </Grid>

      <Grid size={{ xs: 4 }}>
        <b>{StartDate.label.replace("*", "")}</b>
      </Grid>

      <Grid size={{ xs: 0.5 }}></Grid>

      <Grid size={{ xs: 4 }}>
        {latestWorkpost?.startDate && getLocalDateInString(new Date(latestWorkpost?.startDate))}
      </Grid>

      <Grid size={{ xs: 3.5 }}></Grid>

      {userRoles && pcsFilter(userRoles) && <>
        <Grid size={{ xs: 4 }}>
          <b>{PostLevel.label.replace("*", "")}</b>
        </Grid>

        <Grid size={{ xs: 0.5 }}></Grid>

        <Grid size={{ xs: 4 }}>
          {workPostLevels?.find(x => x.id === latestWorkpost?.workPostLevelId)?.value}
        </Grid>

        <Grid size={{ xs: 3.5 }}></Grid>
      </>}

      <Grid size={{ xs: 4 }}>
        <b>{JobTitle.label.replace("*", "")}</b>
      </Grid>

      <Grid size={{ xs: 0.5 }}></Grid>

      <Grid size={{ xs: 4 }}>
        {latestWorkpost?.jobTitle}
      </Grid>

      <Grid size={{ xs: 3.5 }}></Grid>

      <Grid size={{ xs: 4 }}>
        <b>{Country.label.replace("*", "")}</b>
      </Grid>

      <Grid size={{ xs: 0.5 }}></Grid>

      <Grid size={{ xs: 4 }}>
        {countries && countries?.find(x => x.id === latestWorkpost?.countryId)?.value}
      </Grid>

      <Grid size={{ xs: 3.5 }}></Grid>

      {userRoles && pcsFilter(userRoles) &&
        <>
          <Grid size={{ xs: 4 }}>
            <b>{NameOfClinicalSupervisor.label.replace("*", "")}</b>
          </Grid>

          <Grid size={{ xs: 0.5 }}></Grid>

          <Grid size={{ xs: 4 }}>
            {latestWorkpost?.clinicalSupervisor}
          </Grid>

          <Grid size={{ xs: 3.5 }}></Grid>
        </>
      }

      {latestWorkpost?.employerId !== undefined && latestWorkpost?.employerId !== null &&
        latestWorkpost?.employerId !== "" && <>
          <Grid size={{ xs: 4 }}>
            <b>{NameOfEmployer.label.replace("*", "")}</b>
          </Grid>

          <Grid size={{ xs: 0.5 }}></Grid>

          <Grid size={{ xs: 4 }}>
            {hospitals?.find(x => x.id === latestWorkpost?.employerId)?.value}
          </Grid>

          <Grid size={{ xs: 3.5 }}></Grid>
        </>}

      {latestWorkpost?.employerOther !== undefined && latestWorkpost?.employerOther !== null &&
        latestWorkpost?.employerOther !== "" && <>
          <Grid size={{ xs: 4 }}>
            <b>{OtherNameOfEmployer.label.replace("*", "")}</b>
          </Grid>

          <Grid size={{ xs: 0.5 }}></Grid>

          <Grid size={{ xs: 4 }}>
            {latestWorkpost?.employerOther}
          </Grid>

          <Grid size={{ xs: 3.5 }}></Grid>
        </>}
    </Grid>
  </Box>
}
